<template>
  <v-card>
    <v-toolbar class="teal white--text">
      <v-toolbar-title>{{ $t('profile.accesses.title') }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-list>
        <!--<v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="row">
            <td>{{ row.item.ipAddress }}</td>
            <td>{{ row.item.browser }}</td>
            <td class="text-xs-right">{{ $format.date(row.item.actionDate) }}</td>
            <td class="text-xs-right">{{ row.item.actionType }}</td>
          </template>
        </v-data-table>-->

        <model-crud
          :model="model"
          :fetchFilters="fetchFilters"
          :fields="fields"
          :filtering="false"
          :exportable="false"
          :editable="false"
          :deletable="false"
          default-order="actionDate"
          :default-order-asc="false"
          :perPage="10"
        />
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import Access from '@/models/Access'
import ModelCrud from '@/components/ModelCrud'

export default {
  props: ['value'],
  data () {
    return {
      model: Access,
      fetchFilters: {
        'username': '[EQ]' + this.$store.auth.username
      },
      fields: {
        ipAddress: {
          label: this.$t('headers.ipAddress')
        },
        browser: {
          label: this.$t('headers.browser')
        },
        actionDate: {
          label: this.$t('headers.date'),
          type: 'date'
        },
        actionType: {
          label: this.$t('headers.actionType')
        }
      }
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Accesses.vue?1f22ce88